import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from '@betty/toolkit/state';
import {
  getPromos,
  selectPromosDataState,
  selectPromo,
} from '../state/promos/promos.slice';
import { Promotion } from '../state/promos/promos.types';

const usePromo = (id: Promotion['slug'] | Promotion['promotionId']) => {
  const dispatch = useDispatch();

  const promo = useSelector((state) => selectPromo(state, id));
  const promosDataState = useSelector(selectPromosDataState);

  const returnObj = useMemo(
    () => ({
      promo,
      promosDataState,
    }),
    [promo, promosDataState],
  );

  useEffect(() => {
    if (promosDataState === 'idle') {
      dispatch(getPromos());
    }
  }, [dispatch, promosDataState]);

  return returnObj;
};

export default usePromo;
